<!-- src/components/device/commands/ReportIntervalsCards.vue -->
<!-- Rapports de charge et rapport périodique — partagé admin/client. Deux encadrés rendus
     l'un sous l'autre dans la colonne du parent (fragment : pas d'élément racine). -->
<template>
  <div class="bg-white rounded-lg shadow p-4">
    <h3 class="font-semibold text-gray-800">
      {{ $t('cadences.chargeTitre') }}
      <span v-if="technique" class="ml-1 text-xs font-normal text-gray-400">charge_status</span>
    </h3>
    <p class="mt-1 text-sm text-gray-500">
      {{ $t('cadences.chargeIntro') }}
    </p>
    <div class="mt-3 grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="border border-gray-100 rounded-lg p-3">
        <label class="block text-xs font-medium text-gray-600 mb-1">
          {{ $t('cadences.surSecteur') }} <span class="text-gray-400">{{ $t('cadences.plageSecteur') }}</span>
        </label>
        <div class="flex items-center gap-3">
          <input type="range" min="120" max="600" step="60" v-model.number="chargeMains" class="flex-1" />
          <span class="font-mono text-sm w-16 text-right">{{ Math.round(chargeMains / 60) }} min</span>
        </div>
        <button @click="send('set_charge_interval_mains', { v: chargeMains })"
                class="btn btn-primary w-full text-sm mt-2" :disabled="busy">
          {{ $t('cadences.appliquerSecteur') }}
        </button>
        <valeur-rapportee :rapporte="rapporte('charge_interval_mains_s')" :demande="device.charge_interval_mains_s" :libelle="enMinutes" />
      </div>

      <div class="border border-gray-100 rounded-lg p-3">
        <label class="block text-xs font-medium text-gray-600 mb-1">
          {{ $t('cadences.surSolaire') }} <span class="text-gray-400">{{ $t('cadences.plageSolaire') }}</span>
        </label>
        <div class="flex items-center gap-3">
          <input type="range" min="300" max="3600" step="60" v-model.number="chargeSolar" class="flex-1" />
          <span class="font-mono text-sm w-16 text-right">{{ Math.round(chargeSolar / 60) }} min</span>
        </div>
        <button @click="send('set_charge_interval_solar', { v: chargeSolar })"
                class="btn btn-primary w-full text-sm mt-2" :disabled="busy">
          {{ $t('cadences.appliquerSolaire') }}
        </button>
        <valeur-rapportee :rapporte="rapporte('charge_interval_solar_s')" :demande="device.charge_interval_solar_s" :libelle="enMinutes" />
      </div>
    </div>
  </div>

  <div class="bg-white rounded-lg shadow p-4">
    <h3 class="font-semibold text-gray-800">
      {{ $t('cadences.periodiqueTitre') }}
      <span v-if="technique" class="ml-1 text-xs font-normal text-gray-400">status</span>
    </h3>
    <p class="mt-1 text-sm text-gray-500">
      {{ $t('cadences.periodiqueIntro') }}
    </p>
    <div class="mt-3 space-y-3">
      <div>
        <label class="block text-xs font-medium text-gray-600 mb-1">
          {{ $t('cadences.intervalle') }} <span class="text-gray-400">{{ $t('cadences.plageDaily') }}</span>
        </label>
        <div class="flex items-center gap-3">
          <input type="range" min="1" max="168" step="1" v-model.number="daily" class="flex-1" />
          <span class="font-mono text-sm w-16 text-right">{{ daily }} h</span>
        </div>
      </div>
      <div class="flex flex-wrap gap-2">
        <button v-for="h in [12, 24, 48, 72]" :key="h" @click="daily = h" type="button"
                class="btn bg-gray-100 hover:bg-gray-200 text-gray-700 text-xs px-3">{{ h }} h</button>
      </div>
      <button @click="send('set_daily_interval', { v: daily })"
              class="btn btn-primary w-full text-sm" :disabled="busy">
        {{ $t('cadences.appliquerIntervalle') }}
      </button>
        <valeur-rapportee :rapporte="rapporte('daily_interval_h')" :demande="device.daily_interval_h" :libelle="enHeures" />
      <p class="text-xs text-gray-500">{{ $t('cadences.note') }}</p>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, watch } from 'vue';
import ValeurRapportee from './ValeurRapportee.vue';

export default defineComponent({
  name: 'ReportIntervalsCards',
  components: { ValeurRapportee },
  props: {
    device:    { type: Object, required: true },
    send:      { type: Function, required: true },
    busy:      { type: Boolean, default: false },
    technique: { type: Boolean, default: false }
  },
  setup(props) {
    const chargeMains = ref(120);   // secondes — défaut firmware 2 min
    const chargeSolar = ref(900);   // secondes — défaut firmware 15 min
    const daily       = ref(24);    // heures — défaut firmware 24 h
    const suivre = (champ, cible) => watch(() => props.device[champ],
      v => { if (v !== null && v !== undefined) cible.value = Number(v); }, { immediate: true });
    suivre('charge_interval_mains_s', chargeMains);
    suivre('charge_interval_solar_s', chargeSolar);
    suivre('daily_interval_h', daily);
    const rapporte = champ => props.device.reported_config ? props.device.reported_config[champ] : null;
    const enMinutes = v => `${Math.round(Number(v) / 60)} min`;
    const enHeures = v => `${v} h`;
    return { chargeMains, chargeSolar, daily, rapporte, enMinutes, enHeures };
  }
});
</script>
